import React, { useEffect, useState } from "react";
import { Button, Form, Input, Modal } from "antd";
import { reportValidatePostApi, updateTranscriptViewCountApi } from "../api";
import WebUtils from "../components/utils/WebUtils";
import { useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import Utils from "../components/utils/Utils";
import TranscriptMainPage from "../components/transcript/TranscriptMainPage";

function InterviewTranscript() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const loginQuery = queryParams.get("q");

  const decodeValidate = (value) => {
    if (value === null) {
      return null;
    }
    try {
      return atob(value);
    } catch (error) {
      return null; // Or handle it in a way that suits your application
    }
  };
  let decodedLoginQuery = decodeValidate(loginQuery);

  const params = {};
  if (decodedLoginQuery) {
    const paramsArray = decodedLoginQuery.split("&");

    paramsArray.forEach((param) => {
      const [key, value] = param.split("=");
      params[key] = value;
    });
  }

  const interviewId = params.interviewId;
  const passcode = params.passcode;
  const userRole = params.userRole;
  const interviewType = params.interviewType;

  const [passvarified, setPassVarified] = useState(null);
  const [passText, setPassText] = useState(passcode);
  const [interviewIdText, setInterviewIdText] = useState(interviewId);
  const [passModal, setPassModal] = useState(true);
  const [passcodeError, setPassCodeError] = useState();
  const [interviewIdError, setInterviewIdError] = useState();
  const [accessTokenAuth, setAccessTokenAuth] = useState();
  const [loading, setLoading] = useState(false);

  const countApi = async (auth, reqbody) => {
    const url = `${updateTranscriptViewCountApi}?interviewId=${interviewId}`;
    try {
      // setLoading(true);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
        body: JSON.stringify(reqbody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      // setLoading(false);
    }
  };

  const passVarifyFunc = (ip) => {
    setLoading(true);

    let reqCount = {
      osType: Utils.detectOS(),
      osVersion: Utils.getOSVersion(),
      browserType: Utils.browserCheck(),
      browserVersion: Utils.browserVersionCheck(),
      ipAddress: ip,
      systemSpecs: {},
      dateTimeInfo: new Date().toISOString().slice(0, -5),
      logCode: "Validate passcode",
      logMessage: "validation of passcode done",
    };

    let url = `${reportValidatePostApi}?interviewId=${interviewIdText}&interviewPasscode=${passText}&interviewType=${interviewType}`;
    WebUtils.httpOperations(url, {}, "POST", true)
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setPassModal(false);
          setPassVarified(true);
          setAccessTokenAuth(result.data.data.accessToken);
          countApi(result.data.data.accessToken, reqCount);
        } else if (result.data.resultStatusInfo.resultCode === "UNAUTHORIZED") {
          setPassCodeError("Invalid passcode or InterviewId");
        }
        setLoading(false);
      })
      .catch((err) => {
        setPassCodeError("Invalid passcode or InterviewId");
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        passVarifyFunc(data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIpAddress();
  }, []);

  return (
    <>
      {passvarified ? (
        <TranscriptMainPage
          auth={accessTokenAuth}
          interviewId={interviewIdText}
          interviewType={interviewType}
        />
      ) : (
        <>
          {loading && <Loader />}
          <div className=" login-landing-page min-h-screen bg-primaryBg ">
            <Modal
              open={passModal}
              centered
              footer={null}
              size="sm"
              closable={false}
              style={{ borderRadius: 8 }}
              className="custom-modal rounded"
            >
              {/* <Modal.Body> */}
              <div className=" w-75 m-auto">
                <Form layout="vertical" onFinish={passVarifyFunc}>
                  <Form.Item
                    tooltip="Interview Id is required"
                    label=<div className="font-medium text-[.94rem]">
                      Interview Id
                    </div>
                    name="interviewId"
                    initialValue={interviewId} // Set initial value from state or prop
                    rules={[
                      {
                        required: true,
                        message: "Please enter your Interview Id",
                      },
                    ]}
                  >
                    <Input
                      value={interviewIdText}
                      className="rounded"
                      onChange={(e) => {
                        setInterviewIdText(e.target.value);
                        setPassCodeError("");
                      }}
                    />
                    {/* <p className="p-0 m-0" style={{ color: "red" }}>
                  {passcodeError}
                </p> */}
                  </Form.Item>
                  <Form.Item
                    tooltip="Passcode is required"
                    label=<div className="font-medium text-[.94rem]">
                      Passcode
                    </div>
                    name="passcode"
                    initialValue={passcode} // Set initial value from state or prop
                    rules={[
                      {
                        required: true,
                        message: "Please enter your passcode",
                      },
                    ]}
                  >
                    <Input.Password
                      value={passText}
                      className="rounded"
                      onChange={(e) => {
                        setPassText(e.target.value);
                        setPassCodeError("");
                      }}
                    />
                    <p className="p-0 m-0" style={{ color: "red" }}>
                      {passcodeError}
                    </p>
                  </Form.Item>
                  <div className="flex justify-center items-center py-1 mt-2">
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={!passText} // Simplified conditional
                    >
                      View Transcript
                    </Button>
                  </div>
                </Form>
              </div>
              {/* </Modal.Body> */}
            </Modal>
          </div>
        </>
      )}
    </>
  );
}

export default InterviewTranscript;
